module.exports = __webpack_public_path__ + "static/img/lx_blue.2f4ec036.svg";